import React, { SyntheticEvent, useEffect, useState } from 'react';
import { Button, Grid, Header, Icon, Image, Modal } from 'semantic-ui-react';
import { Field } from 'formik';
import { EstateFormProps } from '../UpdateEstateForm';
import { list } from '../../../services/insurer';
import { dangerNotification } from '../../../services/notification';
import Input from '../../../components/Input';
import Toggle from '../../../components/Toggle';
import SectionLabel from '../../../components/SectionLabel';
import { FormikErrorMessage } from '../../../components/ErrorMessage';
import { FieldLabel } from '../../../styles';
import {
  FireInsurersRow,
  InsurerCard,
  InsurerCardContent,
  InsurerCardContentTitle,
  InsurerCardIcon,
  InsurerCardToggleContent,
  NoParamsMessage
} from '../styles';
import { InsurersCodeEnum } from '../../../enums/insurers-code.enum';
import IconButton from '../../../components/IconButton';

export const CapitalizationInsuranceData = (props: EstateFormProps) => {
  const { errors, touched, handleInputChange, values, setFieldValue } = props;
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [availableInsurers, setAvailableInsurers] = useState<any[]>([]);
  const [insurerSelected, setInsurerSelected] = useState<any>();

  useEffect(() => {
    setIsLoading(true);

    list({ availability: 'CAPITALIZATION' })
      .then(result => {
        setAvailableInsurers(result);
      })
      .catch(error => {
        dangerNotification(
          'Oops...',
          'Não foi possível buscar as seguradoras disponíveis'
        );
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [props.values.isPortoTradicionalCapitalizationSelected, values?.capitalizations]);

  const handleToggle = async (e: SyntheticEvent, value: any) => {
    if (value) {
      const insurer = availableInsurers.find(i => i.id == value.name);
      if (value.checked && insurer) {
        if (value.id.includes(InsurersCodeEnum.Porto)) {
          setFieldValue('isPortoTradicionalCapitalizationSelected', true);
        }
        values.capitalizations.push({
          id: insurer.id,
          code: insurer.code,
          name: insurer.name,
          imageUrl: insurer.image
        });
      } else if (!value.checked && insurer) {
        values.capitalizations = values.capitalizations.filter(
          (i: any) => i.id != value.name
        );
        setFieldValue('isPortoTradicionalCapitalizationSelected', false);
      }
      setFieldValue(`values.capitalizations`, values.capitalizations);
    }
  };

  const [openModalConfig, setOpenModalConfig] = useState(false);

  const CapitalizationInsuranceConfigModal = (props: any) => {
    const { name } =
      availableInsurers.find((i: any) => i.id === insurerSelected.id) ?? {};
    return (
      <div>
        <Modal
          style={{ height: 'auto', width: '50vw', zIndex: 10 }}
          closeIcon
          open={openModalConfig}
          onClose={() => setOpenModalConfig(false)}
        >
          <Header style={{ display: 'flex', justifyContent: 'space-between' }}>
            <div style={{ display: 'flex' }}>
              <Icon name={'file alternate outline'} /> {name && `${name}`}
            </div>
          </Header>
          <Modal.Content scrolling>
            {insurerSelected?.code.includes(InsurersCodeEnum.Porto) && (
              <>
                <FieldLabel>Código da Seguradora* </FieldLabel>
                <Field
                  name="portoCode"
                  onChange={(e: React.ChangeEvent<HTMLInputElement>, data: any) => {
                    handleInputChange(data, props);
                  }}
                  component={Input}
                  className={
                    errors && errors.portoCode && touched && touched.portoCode
                      ? 'text-input error'
                      : 'text-input'
                  }
                  fluid
                />
                <FormikErrorMessage component="div" name="portoCode" />
              </>
            )}
            {insurerSelected &&
              !insurerSelected?.code.includes(InsurersCodeEnum.Porto) && (
                <NoParamsMessage>
                  *Não há parâmetros de configuração disponíveis para a seguradora
                  selecionada.
                </NoParamsMessage>
              )}
          </Modal.Content>
          <Modal.Actions>
            <Button color="red" onClick={() => setOpenModalConfig(false)}>
              <Icon name="remove" />
              Sair
            </Button>
            <Button color="green" onClick={() => setOpenModalConfig(false)}>
              <Icon name="checkmark" /> Salvar
            </Button>
          </Modal.Actions>
        </Modal>
      </div>
    );
  };

  return (
    <>
      <SectionLabel text="TÍTULO DE CAPITALIZAÇÃO" />
      <FireInsurersRow>
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            gap: '1rem',
            flexWrap: 'wrap',
            width: '100%'
          }}
        >
          {availableInsurers.map((insurerOption: any) => (
            <div
              key={insurerOption.id}
              style={{
                display: 'flex',
                flex: '0 0 calc((100% - 32px) / 3)',
                gap: '1rem',
                alignItems: 'center',
                marginBottom: '1rem',
                cursor: 'pointer'
              }}
              onClick={() => setInsurerSelected(insurerOption)}
            >
              <InsurerCard
                key={insurerOption.id}
                isSelected={insurerSelected?.id === insurerOption.id}
                onClick={() => setInsurerSelected(insurerOption)}
              >
                <div
                  style={{
                    width: '120px',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center'
                  }}
                >
                  <Image src={insurerOption.image} />
                </div>
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    width: '100%'
                  }}
                >
                  <div
                    style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}
                  >
                    <span>{insurerOption.name}</span>
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'start',
                        alignItems: 'center',
                        gap: 4
                      }}
                    >
                      <Toggle
                        name={insurerOption.id}
                        id={`updateEstate-capitalization-${insurerOption.code}`}
                        label={
                          values.capitalizations.find(
                            (i: any) => i.id === insurerOption.id
                          )
                            ? 'ATIVA'
                            : 'INATIVA'
                        }
                        checked={
                          !!values.capitalizations.find(
                            (i: any) => i.id === insurerOption.id
                          )
                        }
                        onChange={handleToggle}
                      />
                    </div>
                  </div>
                </div>
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center'
                  }}
                >
                  <div
                    style={{
                      border: '1px solid rgba(34, 36, 38, 0.15)',
                      borderRadius: '5px',
                      padding: '10px',
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      cursor: 'pointer'
                    }}
                  >
                    <IconButton
                      name="cog"
                      style={{ fontSize: 24, margin: '2px 0 0 0', cursor: 'pointer' }}
                      onClick={() => setOpenModalConfig(true)}
                    />
                  </div>
                </div>
              </InsurerCard>
            </div>
          ))}
        </div>

        {insurerSelected && CapitalizationInsuranceConfigModal(props)}
      </FireInsurersRow>
    </>
  );
};
